<template>
    <div class="dc-reports">
        <app-docs :docs="reports" :list="true"></app-docs>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import Reports from './reports.json'
import ShareButton from "../shared/ShareButton";
import Docs from "../shared/Docs";
export default {
  components: {
    appShareButton: ShareButton,
    appDocs: Docs
  },
  data() {
      return {
          reports: Reports
      }
  }
};</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/download-center/Reports.vue